import { CommonModule } from '@angular/common';
import { Component, OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { DeleteVehicleDialogComponent } from '@app/components/account/vehicles/delete-vehicle-dialog/delete-vehicle-dialog.component';
import { AddWalletDialogComponent } from '@app/components/wallet/add-wallet-dialog/add-wallet-dialog.component';
import { WalletTableComponent } from '@app/components/wallet/wallet-table/wallet-table.component';
import { appSchemeUrl } from '@app/pages/redirect-wallet/redirect-wallet.component';
import { AuthService } from '@app/services/auth.service';
import { Wallet } from '@app/services/user.interface';
import { UserService } from '@app/services/user.service';
import { firstValueFrom } from 'rxjs';
import { DevcycleService, FEATURE_FLAGS } from '@app/services/devcycle.service';

export const CARD_NAMES = {
  visa: "Visa",
  mastercard: "MasterCard",
  amex: "American Express",
  discover: "Discover",
  jcb: "JCB",
  diners_club: "Diners Club",
  unionpay: "UnionPay"
};

@Component({
  selector: 'app-wallet',
  standalone: true,
  imports: [WalletTableComponent, MatIconModule, MatButtonModule, CommonModule, MatProgressSpinnerModule],
  templateUrl: './wallet.component.html',
  styleUrl: './wallet.component.scss'
})
export class WalletComponent implements OnInit {
  wallets: Wallet[] = [];
  cardNames = CARD_NAMES;
  isLoading = signal(false);

  constructor(private dialog: MatDialog, private userService: UserService, private authService: AuthService, private route: ActivatedRoute, private router: Router, private devcycleService: DevcycleService) {}

  async ngOnInit() {
    if (!this.devcycleService.getFeatureFlag(FEATURE_FLAGS.WALLET_SETTINGS_ENABLE, false)) {
      this.router.navigate(['/account']);
      return;
    }

    await this.getWallets();
  }

  async getWallets() {
    const wallets = await firstValueFrom(this.userService.getWallets(this.authService.userSignal().uid));
    this.wallets = wallets;
  }

  openAddDialog() {
    const dialogRef = this.dialog.open(AddWalletDialogComponent, {
      width: '500px',
    });
    dialogRef.afterClosed().subscribe(() => {
      this.getWallets();

      this.redirectBackToApp();
    });
  }

  redirectBackToApp() {
    if ((this.route.snapshot.queryParams as any)?.from === 'app-redirect') {
      setTimeout(() => {
        window.location.replace(appSchemeUrl); // Redirect back to the app
      }, 1500);
    }
  }

  async setAsDefault(id: string) {
    this.isLoading.set(true);
    await firstValueFrom(this.userService.selectDefaultCard(this.authService.userSignal().uid, id));

    await this.getWallets();
    this.isLoading.set(false);

    this.redirectBackToApp();
  }

  async deleteWallet(id: string) {
    const dialogRef = this.dialog.open(DeleteVehicleDialogComponent, {
      width: '500px',
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        this.isLoading.set(true);
        await firstValueFrom(this.userService.deleteCard(this.authService.userSignal().uid, id));

        await this.getWallets();
        this.isLoading.set(false);

        this.redirectBackToApp();
      }
    });
  }
}
